import { ExportConfigurationModule } from './export-configuration/export-configuration.module';
import { NgModule } from '@angular/core';
import { ConfigurationsService } from './export-configuration/configurations/configurations.service';
import { ConfigurationTemplatesService } from './export-configuration/configuration-templates/configuration-templates.service';
import { ExportInterfaceConfigTemplateClient, SalesPersonCodeClient } from '../base/models/models.swagger.generated';
import { AssetsModule } from './assets/assets.module';
import { AdministrationRoutingModule } from './administration/administration-routing.module';
import { ImportConfigurationRoutingModule } from './import-configuration/import-configuration-routing.module';
import { SettingsRoutingModule } from './settings/settings-routing.module';
import { ManualImportRoutingModule } from './manual-import/manual-import-routing.module';
import { VendorScoreCardRoutingModule } from './vendor-score-card/vendor-score-card-routing.module';

@NgModule({
  imports: [
    AdministrationRoutingModule,
    ManualImportRoutingModule,
    ImportConfigurationRoutingModule,
    ExportConfigurationModule,
    AssetsModule,
    SettingsRoutingModule,
    VendorScoreCardRoutingModule
  ],
  declarations: [
  ],
  exports: [
  ],
  providers: [
    ConfigurationsService,
    ConfigurationTemplatesService,
    ExportInterfaceConfigTemplateClient,
    SalesPersonCodeClient,
  ],
})
export class DomainModule {
}
